import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import {
  getInvoice,
  cancelInvoice,
} from "../../../../services/finance/invoice";
import Illustration from "../../../../partials/content/Illustration";
import ContentLayout from "../../../../partials/content/ContentLayout";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Card } from "primereact/card";
import NumberFormat from "react-number-format";
import { Badge } from "react-bootstrap";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const InvoiceList = ({ history }) => {
  const { reload } = useGlobalData();
  const [invoices, setInvoices] = useState([]);
  const [fullyPaids, setFullyPaids] = useState(0);
  const [partiallyPaids, setPartiallyPaids] = useState(0);
  const [unpaids, setUnpaids] = useState(0);
  const [auth, setAuth] = useState({ create: false });
  useEffect(() => {
    getInvoicesData();
  }, [reload]);

  async function getInvoicesData() {
    const response = await getInvoice();
    const { data, auth } = response.data;
    setInvoices(data.invoices);
    setAuth(auth);
    const fullyPaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 3
    );
    const partiallyPaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 2
    );
    const unpaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 1
    );
    setFullyPaids(fullyPaids.length);
    setPartiallyPaids(partiallyPaids.length);
    setUnpaids(unpaids.length);
  }

  const invoiceDetailColumn = [
    {
      header: "Document Reference",
      field: "docRefDesc",
      type: "string",
    },
    {
      header: "Quotation ID",
      field: "quotationCode",
      type: "string",
    },
    {
      header: "Sales Order ID",
      field: "salesOrderCode",
      type: "string",
    },
    {
      header: "Delivery ID",
      field: "deliveryID",
      type: "string",
    },
    {
      header: "Direct Sales ID",
      field: "directSalesID",
      type: "string",
    },
    {
      header: "Cash Account",
      field: "cashAccountName",
      type: "string",
    },
    {
      header: "Deadline Date",
      field: "deadlineDate",
      type: "date",
    },
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "All Services Delivered",
      field: "servicesDel",
      type: "string",
    },
    {
      header: "Approval Status",
      field: "approvalStatusDesc",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-success">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-check-circle kt-font-success" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">FULLY PAID</div>
                </div>
                <Badge variant="success">{fullyPaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-warning">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-exclamation-circle kt-font-warning" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">
                    PARTIALLY PAID
                  </div>
                </div>
                <Badge variant="warning">{partiallyPaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-danger">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-times-circle kt-font-danger" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">UNPAID</div>
                </div>
                <Badge variant="danger">{unpaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <ContentLayout>
        {invoices.length ? (
          <React.Fragment>
            <CustomDataTable
              data={invoices}
              dataDetailColumns={invoiceDetailColumn}
              onRefreshData={() => {
                getInvoicesData();
              }}
              tableName="invoice"
              selectionMode="checkbox"
              columns={[
                {
                  selectionMode: "multiple",
                },
                {
                  header: "A/R Invoice ID",
                  field: "invoiceCode",
                  body: (rowData) => {
                    if (rowData.approvalStatus === 1) {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.invoiceCode}</span>
                            <BootstrapTooltip title="Document Waiting For Approval">
                              <span className="ml-2">
                                <i className="far fa-clock kt-font-warning"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    } else if (rowData.approvalStatus === 2) {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.invoiceCode}</span>
                            <BootstrapTooltip title="Document Approved">
                              <span className="ml-2">
                                <i className="fas fa-check kt-font-success"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    } else if (rowData.approvalStatus === 3) {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.invoiceCode}</span>
                            <BootstrapTooltip title="Document Rejected">
                              <span className="ml-2">
                                <i className="fas fa-times kt-font-danger"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <React.Fragment>
                          <span>
                            <span>{rowData.invoiceCode}</span>
                            <BootstrapTooltip title="Document No Need Approval">
                              <span className="ml-2">
                                <i className="fas fa-check kt-font-primary"></i>
                              </span>
                            </BootstrapTooltip>
                          </span>
                        </React.Fragment>
                      );
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Customer Name",
                  field: "customer.customerName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.customer.customerName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Invoice Date",
                  field: "invoiceDate",
                  body: (rowData) => formatDate(rowData.invoiceDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Goods Issue Status",
                  field: "giStatusDesc",
                  body: (rowData) => {
                    if (rowData.giStatus === 1) {
                      return (
                        <Badge variant="danger">{rowData.giStatusDesc}</Badge>
                      );
                    } else if (rowData.giStatus === 2) {
                      return (
                        <Badge variant="warning">{rowData.giStatusDesc}</Badge>
                      );
                    } else if (rowData.giStatus === 3) {
                      return (
                        <Badge variant="success">{rowData.giStatusDesc}</Badge>
                      );
                    } else {
                      return (
                        <Badge variant="dark">{rowData.giStatusDesc}</Badge>
                      );
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Payment Status",
                  field: "paymentStatus",
                  body: (rowData) => {
                    if (rowData.paymentStatus === 1) {
                      return (
                        <Badge variant="danger">
                          {rowData.paymentStatusDesc}
                        </Badge>
                      );
                    } else if (rowData.paymentStatus === 2) {
                      return (
                        <Badge variant="warning">
                          {rowData.paymentStatusDesc}
                        </Badge>
                      );
                    } else if (rowData.paymentStatus === 3) {
                      return (
                        <Badge variant="success">
                          {rowData.paymentStatusDesc}
                        </Badge>
                      );
                    } else {
                      return (
                        <Badge variant="dark">
                          {rowData.paymentStatusDesc}
                        </Badge>
                      );
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Currency",
                  field: "currency.currencyCode",
                  body: null,
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Billing Amount",
                  field: "billAmount",
                  body: (rowData) => (
                    <NumberFormat
                      value={rowData.billAmount}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                      renderText={(value) => (
                        <div className="float-right">
                          {rowData.currency.currencyCode} {value}
                        </div>
                      )}
                    />
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      {(rowData.approvalProcessID === 0 ||
                        rowData.approvalProcess.statusID === 2 ||
                        rowData.approvalProcess.statusID === 3) &&
                      rowData.paymentStatus === 1 &&
                      rowData.docRef !== "4" &&
                      rowData.docRef !== "5" ? (
                        <BootstrapTooltip title="Edit Account Receivable Invoice">
                          <button
                            type="button"
                            onClick={() => {
                              history.push(
                                "/finance/edit-invoice/" + rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                      <BootstrapTooltip title="Account Receivable Invoice Detail">
                        <button
                          type="button"
                          onClick={() => {
                            history.push(
                              "/finance/invoice-detail/" + rowData.ID
                            );
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-list-alt"></i>
                        </button>
                      </BootstrapTooltip>
                      {(rowData.approvalProcessID === 0 ||
                        rowData.approvalProcess.statusID === 2 ||
                        rowData.approvalProcess.statusID === 3) &&
                      rowData.paymentStatus === 1 &&
                      rowData.docRef !== "4" &&
                      rowData.docRef !== "5" ? (
                        <BootstrapTooltip title="Delete Account Receivable Invoice">
                          <button
                            type="button"
                            onClick={() => handleDeleteInvoice(rowData.ID)}
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          </React.Fragment>
        ) : (
          <Illustration
            imageSource="INVIFO Payment.png"
            description="Hooray! You're ready to have your first Account Receivable Invoice!"
            guidance="Hint: manage your A/R invoices for customers to be more professional"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
    </React.Fragment>
  );

  async function handleDeleteInvoice(invoiceID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Account Receivable Invoice ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelInvoice(invoiceID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getInvoicesData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
};

export default InvoiceList;
